import { getBottomLeft, getTopRight } from 'ol/src/extent';
import { toLonLat } from 'ol/src/proj';

import { fetchers, mapConfig, nameToIcon } from 'shared';

import { renderPoiHoverTooltip, renderPoiSelectedTooltip } from './TooltipRenderer';
import { createMarker } from '../../utils';

let latestSettings;
let lastSelectedMarker = null;

const settingToLetter = {
	educationalInstitutions: 'B',
	recreation: 'C',
	hospitals: 'F',
	culture: 'G',
	landmarks: 'H',
	clubs: 'J',
	foodAndDrink: 'K',
	aroundBike: 'M',
};

const categoryToSetting = {
	Bildungseinrichtungen: 'educationalInstitutions',
	Freizeit: 'recreation',
	'Krankenhäuser & Kliniken': 'hospitals',
	Kultur: 'culture',
	Sehenswürdigkeiten: 'landmarks',
	'Verbände & Vereine': 'clubs',
	'Essen & Trinken': 'foodAndDrink',
	'Rund ums Rad': 'aroundBike',
};

/**
 *
 * @param {import('ol/src/Map').default} map
 * @param {object} settings
 * @param {function} addPoint
 * @param {function} setPoiMarkers
 * @returns
 */
export default async function updatePOIMarkers(map, settings, addPoint, setPoiMarkers) {
	latestSettings = settings;

	if (map.getView().getZoom() < mapConfig.minZoomLevel.pois) {
		setPoiMarkers([]);
		return;
	}

	const extent = map.getView().calculateExtent();
	const bottomLeft = toLonLat(getBottomLeft(extent));
	const topRight = toLonLat(getTopRight(extent));

	const usedCategories = Object.keys(latestSettings)
		.filter(category => latestSettings[category])
		.map(category => settingToLetter[category]);

	let pois = await fetchers.fetchPOIsByArea(
		bottomLeft[1],
		bottomLeft[0],
		topRight[1],
		topRight[0],
		usedCategories,
	);

	// Filter out pois with invalid categories (if categories have changed since starting the request)
	pois = pois.filter(poi => latestSettings[categoryToSetting[poi.category]]);

	const newPoiMarkers = [];

	// Draw new markers
	pois.forEach(poi => {
		const marker = createMarker(poi, {
			type: `poi_${nameToIcon(poi.category)}`,
			title: poi.name,
			subtitle: poi.parent?.name,
			address: poi.address || '',
			category: poi.category,
			locationtype: 'poi',
			vvsId: poi.id,
			state: 2,
			onHover: () => {
				// Only show hover tooltip if not selected
				if (!marker.get('selected')) {
					renderPoiHoverTooltip(poi, marker, map);
				}
			},
			onClick: () => {
				// Clear previous selection
				if (lastSelectedMarker !== null && lastSelectedMarker !== marker) {
					lastSelectedMarker.set('selected', false);
					lastSelectedMarker.changed();
				}
				
				// Mark as selected and show selected tooltip with button
				marker.set('selected', true);
				marker.changed();
				lastSelectedMarker = marker;
				
				renderPoiSelectedTooltip(poi, marker, map, addPoint);
			},
		});

		newPoiMarkers.push(marker);
	});

	setPoiMarkers(newPoiMarkers);
}
